
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 25h45m-35-17.5v5m25-5v5m-27 40h29c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185c.545-1.07.545-2.47.545-5.27v-24c0-2.8 0-4.2-.545-5.27a4.999 4.999 0 00-2.185-2.185C48.7 12.5 47.3 12.5 44.5 12.5h-29c-2.8 0-4.2 0-5.27.545a4.999 4.999 0 00-2.185 2.185C7.5 16.3 7.5 17.7 7.5 20.5v24c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185c1.07.545 2.47.545 5.27.545z","stroke":"#000","stroke-width":"5"}})])
          )
        }
      }
    